module.exports = __webpack_public_path__ + "media/assets/icons/close-5bc50fbca804099382a34f8530635d97.svg";